import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import {
  HOME_ONE_SERP,
  SERP_PRODUCT_DETAIL_CLICK,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

export default () => {
  const { pageType } = store.getPublicRuntimeConfig()?.pageProperties || {}
  const { isEnabled } = getExperimentOnClient(HOME_ONE_SERP)
  const serpContainer = document.querySelector<HTMLElement>('.o-SearchResults')

  if (pageType !== PAGE_TYPE_SEARCH_RESULTS || !isEnabled || !serpContainer) {
    return
  }

  void activateExperiment(HOME_ONE_SERP)

  serpContainer?.addEventListener('click', e => {
    const element = <HTMLElement>e.target

    if (element.closest('[data-clientside-hook~="FilteredProductListItem"]')) {
      trackOptimizelyEvent(SERP_PRODUCT_DETAIL_CLICK)
    }
  })
}
